export enum LookupFieldType {
  forms = 0,
  licenses = 1,
  accounts = 2,
  objectModels = 3
}

export function getLookupFieldTypeLabel(num: number): string {
  switch (num) {
    case LookupFieldType.forms:
      return "Forms";
    case LookupFieldType.licenses:
      return "Licenses";
    case LookupFieldType.accounts:
      return "Accounts";
    case LookupFieldType.objectModels:
      return "Object Models";
  }
}